/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ConcessionsHistoryColumns {
    SPECIAL = 'special',
    CONCESSION_START_DATE = 'concession_start_date',
    CONCESSION_END_DATE = 'concession_end_date',
}
